export default __webpack_public_path__ + "static/media/logo-black-white.d66bfdc3.png";